import React from "react";
import classNames from "classnames";

import styles from "./Legal.css";

var Privacy = function Privacy() {
  return React.createElement(
    "div",
    { className: classNames(styles.postsMain, styles.boxWrapper) },
    React.createElement(
      "div",
      { className: styles.widget },
      React.createElement(
        "div",
        { className: styles.widgetBody },
        React.createElement(
          "div",
          { className: styles.blueHeading },
          "PRIVACY POLICY"
        ),
        React.createElement(
          "p",
          null,
          "This privacy policy was last updated on January 12, 2017."
        ),
        React.createElement(
          "p",
          null,
          "Thank you for visiting ",
          React.createElement(
            "a",
            { href: "https://www.axios.com" },
            "axios.com"
          ),
          ", a media destination for news and information. Axios Media Inc. (\u201C",
          React.createElement(
            "strong",
            null,
            "Axios Media,"
          ),
          "\u201D \u201C",
          React.createElement(
            "strong",
            null,
            "we,"
          ),
          "\u201D \u201C",
          React.createElement(
            "strong",
            null,
            "us"
          ),
          "\u201D and \u201C",
          React.createElement(
            "strong",
            null,
            "our"
          ),
          "\u201D) is committed to protecting your privacy. We have prepared this Privacy Policy to describe our practices regarding the Personal Information (defined below) we collect from users through the websites on which this Privacy policy is displayed (each, a \u201C",
          React.createElement(
            "strong",
            null,
            "Site"
          ),
          "\u201D) and in connection with services and content made available by us through the Sites and our third party distributors Facebook and Apple News (collectively \u201CServices\u201D). This Privacy Policy does not apply to our interactions with you outside of the Services (e.g., if you call our offices by telephone). Capitalized terms not otherwise defined in this Privacy Policy have the meanings given in our Terms of Use located at ",
          React.createElement(
            "a",
            { href: "#tos" },
            "www.axios.com/sp/privacy-and-terms/#tos"
          ),
          " (the \u201C",
          React.createElement(
            "strong",
            null,
            "Terms"
          ),
          "\u201D)."
        ),
        React.createElement(
          "p",
          null,
          "This Privacy Policy will apply whether you are a \u201C",
          React.createElement(
            "strong",
            null,
            "Visitor"
          ),
          "\u201D (which means that you simply browse the Services) or an \u201C",
          React.createElement(
            "strong",
            null,
            "Authorized User"
          ),
          "\u201D (which means you have registered to use the Services). Visitors and Authorized Users are individually referred to as a \u201C",
          React.createElement(
            "strong",
            null,
            "User"
          ),
          "\u201D and collectively as \u201C",
          React.createElement(
            "strong",
            null,
            "Users"
          ),
          "\u201D."
        ),
        React.createElement(
          "ol",
          null,
          React.createElement(
            "li",
            null,
            React.createElement(
              "u",
              null,
              "User Consent"
            ),
            ". By submitting Personal Information through our Services, you agree to the terms of this Privacy Policy and you expressly consent to the collection, use and disclosure of your Personal Information in accordance with this Privacy Policy."
          ),
          React.createElement(
            "li",
            null,
            React.createElement(
              "u",
              null,
              "A Note to Users Outside of the United States"
            ),
            ". Your Personal Information may be processed in the country in which it was collected and in other countries, including the United States, where laws regarding processing of Personal Information may be less stringent than the laws in your country. By using the Services you agree to such processing."
          ),
          React.createElement(
            "li",
            null,
            React.createElement(
              "p",
              null,
              React.createElement(
                "u",
                null,
                "Information We Collect"
              ),
              ". \u201C",
              React.createElement(
                "strong",
                null,
                "Personal Information"
              ),
              "\u201D means information that allows someone to identify or contact you, including, for example, your name, address, telephone number, e-mail address, as well as any other non-public information about you that is associated with or linked to any of the foregoing Information. \u201C",
              React.createElement(
                "strong",
                null,
                "Anonymous Information"
              ),
              "\u201D means Information that is not associated with or linked to your Personal Information. Anonymous Information does not, by itself, permit the identification of individual persons. We collect Personal Information and Anonymous Information, as described below through the Services."
            ),
            React.createElement(
              "ol",
              null,
              React.createElement(
                "li",
                null,
                React.createElement(
                  "p",
                  null,
                  React.createElement(
                    "u",
                    null,
                    "Information You Provide to Us"
                  ),
                  "."
                ),
                React.createElement(
                  "ul",
                  null,
                  React.createElement(
                    "li",
                    null,
                    "Registration. When you register to become an Authorized User and open an account (an \u201CAccount\u201D) we collect your name, email address and a password."
                  ),
                  React.createElement(
                    "li",
                    null,
                    "SNS Login. If you prefer, you may logon as an Authorized User by using social networking sites (e.g., Facebook, Google or LinkedIN) (each an \u201CSNS\u201D), in which case we will receive from the SNS only the information that you authorize us to receive from the SNS."
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Profiles. The information collected during registration is used to initiate a personal profile. You may be able to add to your personal profile by providing additional information. As described in more detail below, we may add to your profile based on your interactions with the Services."
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Reporter Communications. As a news organization, we encourage you to communicate directly with our reporters through email and other means. Unless you communicate with reporters through the ",
                    React.createElement(
                      "a",
                      { href: "#privacy-tipline" },
                      "Tipline"
                    ),
                    ", these communications are Personal Information, on the record, and may be used by our reporters publically and as otherwise provided in this Privacy Policy."
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Information Collected from Others About You. We may receive Personal and/or Anonymous Information about you from third parties. We may add this information to the information we have already collected from you via the Services and use it as contemplated by this Privacy Policy. You may contact us at ",
                    React.createElement(
                      "a",
                      { href: "mailto:info@axios.com" },
                      "info@axios.com"
                    ),
                    " to request the removal of this information from our database."
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Feedback. If you provide us feedback or contact us via e-mail, we will collect your name and e-mail address, as well as any other content included in the e-mail, in order to send you a reply."
                  ),
                  React.createElement(
                    "li",
                    { id: "privacy-tipline" },
                    "Tipline. Axios is a news organization. We encourage Users to provide us tips about news and stories. You may do so at ",
                    React.createElement(
                      "a",
                      { href: "https://www.axios.com/tips/" },
                      "https://www.axios.com/tips/"
                    ),
                    ". When you submit information through the Tipline, you do so anonymously as we do not associate the tip information with any Personal Information. Any tips you provide are used by our editorial team on background and we verify the information in accordance with our editorial policies before publishing any such information. To be clear, we are not under any obligation to use any information that comes in through the Tipline."
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Other Information. We may also collect Personal Information in other ways within the Services, where we state that Personal Information is being collected. For example, as part of a survey, competition, sweepstakes or contest."
                  )
                )
              ),
              React.createElement(
                "li",
                null,
                React.createElement(
                  "p",
                  null,
                  React.createElement(
                    "u",
                    null,
                    "Information Collected via Technology"
                  ),
                  "."
                ),
                React.createElement(
                  "ul",
                  null,
                  React.createElement(
                    "li",
                    null,
                    React.createElement(
                      "u",
                      null,
                      "Log Files"
                    ),
                    ". As is true of most websites, we gather certain information automatically and store it in log files. This information includes IP addresses, browser type, Internet Service Provider (ISP), operating systems, date/time stamp and clickstream data. We use this information to analyze trends, administer the Site, track users\u2019 movements around the Site, gather demographic information about our user base, and better tailor our Services to our users\u2019 needs."
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(
                      "u",
                      null,
                      "Cookies"
                    ),
                    ". Like many online services, we use cookies to collect information. \u201C",
                    React.createElement(
                      "strong",
                      null,
                      "Cookies"
                    ),
                    "\u201D are small files that a website or its service provider transfers to your computer\u2019s web browser that enables the website\u2019s or service provider\u2019s systems to recognize your browser and capture and remember certain information. We may use Cookies to help us understand your preferences based on previous or current activity with the Services (as further described below in the section on advertising) and compile aggregate data about traffic and interaction with the Services so that we can offer better experiences and tools in the future. If you decide that you no longer wish to accept Cookies from our Services, then you can instruct your browser, by changing its settings, to stop accepting Cookies or to prompt you before accepting a Cookie from the websites you visit. If you turn Cookies off, you won\u2019t have access to certain features and some of our Services may not function properly."
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(
                      "u",
                      null,
                      "Pixel Tags"
                    ),
                    ". We use \u201C",
                    React.createElement(
                      "strong",
                      null,
                      "Pixel Tags"
                    ),
                    "\u201D (also referred to as clear gifs, web beacons, or web bugs). Pixel Tags are tiny graphic images with a unique identifier, similar in function to Cookies, that are used to track online movements of users. In contrast to Cookies, which are stored on a user\u2019s computer hard drive, Pixel Tags are embedded invisibly in web pages. Pixel Tags also allow us to send e-mail messages in a format users can read and they tell us whether e-mails have been opened. We may use this information to reduce or eliminate messages sent to a user."
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(
                      "u",
                      null,
                      "Do Not Track Signals"
                    ),
                    ". Some web browsers may transmit \u201Cdo not track\u201D signals to the websites and other online services with which your web browser communicates. There is no standard that governs what, if anything, websites should do when they receive these signals. We currently do not take action in response to these signals."
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(
                      "p",
                      null,
                      "Collection of ",
                      React.createElement(
                        "u",
                        null,
                        "Information in Connection with Advertising"
                      ),
                      "."
                    ),
                    React.createElement(
                      "ul",
                      null,
                      React.createElement(
                        "li",
                        null,
                        "Through the use of Cookies and Pixel Tags, we may associate your activities on the Services with certain interests or characteristics. Based on your interests, demographic information and /or your Profile, we may serve you advertising and content through the Services that is likely to be of the most interest to you."
                      ),
                      React.createElement(
                        "li",
                        null,
                        "Advertisers that advertise on the Services may use Cookies and Pixel Tags to learn more about your interests. In addition, we may use third parties to assist us in selecting and serving advertisements through the Services \u2013 and these third parties may also collect information about your visits to this and other websites using Cookies, Pixel Tags or other technologies. Information collected by advertisers and these third party companies may be used by them, among other things, to deliver advertising targeted to your interests on websites and in applications that are not affiliated with us. If you would like more information about this practice and to know your choices about not having this information used by these companies, you may so by visiting ",
                        React.createElement(
                          "a",
                          { href: "http://www.aboutads.info/", target: "_blank" },
                          "www.aboutads.info/"
                        ),
                        " or ",
                        React.createElement(
                          "a",
                          { href: "http://www.networkadvertising.org/choices/", target: "_blank" },
                          "networkadvertising.org/choices/"
                        ),
                        ", or if you are located in the European Union ",
                        React.createElement(
                          "a",
                          { href: "http://www.youronlinechoices.eu/", target: "_blank" },
                          "www.youronlinechoices.eu/"
                        ),
                        "."
                      )
                    )
                  ),
                  React.createElement(
                    "li",
                    null,
                    React.createElement(
                      "u",
                      null,
                      "Analytic Services"
                    ),
                    ". We use third party analytics services such as Google Analytics (\u201C",
                    React.createElement(
                      "strong",
                      null,
                      "Analytics Services"
                    ),
                    "\u201D) to help analyze how users use the Services. The Analytics Services use information generated by Cookies or other technologies about your use of our Site and Services to compile reports on user activity, which we use to improve our Services. Analytics Services may transfer information to third parties where required to do so by law or where such third parties process information on their behalf. Each Analytics Service\u2019s ability to use and share information it collects is restricted by its Terms of Use and Privacy Policy. By using our Site and Services, you consent to the processing of data about you by Analytics Services in the manner and for the purposes set out above. For a full list of Analytics Services, please contact us at ",
                    React.createElement(
                      "a",
                      { href: "mailto:info@axios.com" },
                      "info@Axios.com"
                    ),
                    "."
                  )
                )
              )
            )
          ),
          React.createElement(
            "li",
            null,
            React.createElement(
              "p",
              null,
              React.createElement(
                "u",
                null,
                "Use of Your Personal Information"
              )
            ),
            React.createElement(
              "ol",
              null,
              React.createElement(
                "li",
                null,
                React.createElement(
                  "p",
                  null,
                  React.createElement(
                    "u",
                    null,
                    "General Use"
                  ),
                  ". In general, Personal Information you submit to us is used either to respond to requests that you make, or to aid us in serving you better. We may use your Personal Information in the following ways:"
                ),
                React.createElement(
                  "ul",
                  null,
                  React.createElement(
                    "li",
                    null,
                    "Facilitate the creation of and secure your Account on our network;"
                  ),
                  React.createElement(
                    "li",
                    null,
                    "When you create an Account, you may receive an e-mail from us to verify ownership of the email address provided when your Account was created"
                  ),
                  React.createElement(
                    "li",
                    null,
                    "We may use your e-mail address information to provide you with administrative email notifications, such as Services updates"
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Provide the Services you request"
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Provide improved administration of our Site and Services"
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Respond to your inquires and other requests"
                  ),
                  React.createElement(
                    "li",
                    null,
                    "For fraud protection and/or to verify your identity; and"
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Customize the content and advertisements you see based upon your interests and Profile"
                  ),
                  React.createElement(
                    "li",
                    null,
                    "Send newsletters, surveys, offers and other promotional materials related to our Services and for the benefit of our advertising and marketing partners."
                  )
                )
              ),
              React.createElement(
                "li",
                null,
                React.createElement(
                  "p",
                  null,
                  React.createElement(
                    "u",
                    null,
                    "Creation of Anonymous Information"
                  ),
                  ". We may create Anonymous Information records from Personal Information by excluding information (such as your name) that make the Information personally identifiable to you. We use this Anonymous Information to analyze request and usage patterns so that we may enhance the content of our Services and improve Site navigation. We reserve the right to use and share Anonymous Information for any purpose."
                )
              )
            )
          ),
          React.createElement(
            "li",
            null,
            React.createElement(
              "p",
              null,
              React.createElement(
                "u",
                null,
                "How Do We Share Your Personal Information"
              ),
              "? We disclose your personal information as described below and elsewhere in this Privacy Policy."
            ),
            React.createElement(
              "ol",
              null,
              React.createElement(
                "li",
                null,
                React.createElement(
                  "u",
                  null,
                  "Third Party Service Providers"
                ),
                ". We may share your personal information with third party service providers to: (i) provide you with the Services; (ii) facilitate creation of Accounts; (iii) provide technical support; and/or (iv) provide other services to us."
              ),
              React.createElement(
                "li",
                null,
                React.createElement(
                  "u",
                  null,
                  "Affiliates and Corporate Restructuring"
                ),
                ". We may share your Personal Information with our parent company, subsidiaries, joint ventures, or other companies under a common control (\u201C",
                React.createElement(
                  "strong",
                  null,
                  "Affiliates"
                ),
                "\u201D), in which case we will require our affiliates to honor this Privacy Policy. We may also share some or all of your Personal Information in connection with any merger, financing, acquisition or dissolution transaction or proceeding involving sale, transfer, divestiture, or disclosure of all or a portion of our business or assets. In the event of an insolvency, bankruptcy, or receivership, personal information may also be transferred as a business asset. If another company acquires our company, business, or assets, that company will assume the rights and obligations regarding your personal information as described in this Privacy Policy."
              ),
              React.createElement(
                "li",
                null,
                React.createElement(
                  "u",
                  null,
                  "Social Networking Sites"
                ),
                ". Some of our Services may enable you to post content to SNSs, such as Facebook or Twitter. If you choose to do this, we will provide information to such SNSs in accordance with your elections. You are solely responsible for your use of such SNSs and it is your responsibility to review the terms of use and privacy policy of the third party provider of such SNSs. We will not be responsible or liable for: (i) the availability or accuracy of such SNSs; (ii) the content, products or services on or availability of such SNSs; or (iii) your use of any such SNSs."
              ),
              React.createElement(
                "li",
                null,
                React.createElement(
                  "u",
                  null,
                  "Other Disclosures"
                ),
                ". Regardless of any choices you make regarding your personal information (as described below), we may disclose Personal Information if it believes in good faith that such disclosure is necessary (i) in connection with any legal investigation; (ii) to comply with relevant laws or to respond to subpoenas or warrants served on us; (iii) to protect or defend our rights or property or those of our Users; and/or (iv) to investigate or assist in preventing any violation or potential violation of the law, this Privacy Policy, or our Terms of Use."
              )
            )
          ),
          React.createElement(
            "li",
            null,
            React.createElement(
              "u",
              null,
              "Your Choices Regarding Your Personal Information"
            ),
            " Newsletters and email. We will periodically send you newsletters and e-mails that promote the use of our Services. When you receive newsletters or promotional communications from us, you may indicate a preference to stop receiving further communications from us and you will have the opportunity to \u201Copt-out\u201D by following the unsubscribe instructions provided in the e-mail you receive, by terminating your Account or by contacting us directly (please see contact information below). You may also limit the communications you receive from us through your account settings feature within the Services. Even if you opt of receiving marketing related messages, we will continue to send messages regarding the administration of the Services."
          ),
          React.createElement(
            "li",
            null,
            React.createElement(
              "u",
              null,
              "Correcting, Updating or Deleting Your Personal Information"
            ),
            ". You can correct, update or delete some of your Personal Information by re-registering and/or editing your profile via the Services. We will use commercially reasonable efforts to honor requests to delete personal information. We may retain an archived copy of your records as required by law or for legitimate business purposes. "
          ),
          React.createElement(
            "li",
            null,
            React.createElement(
              "u",
              null,
              "Changes to This Privacy Policy"
            ),
            ". This Privacy Policy may be updated from time to time for any reason. We will notify you of any changes to our Privacy Policy by posting the new Privacy Policy here and we will change the \u201C",
            React.createElement(
              "strong",
              null,
              "Last Updated"
            ),
            "\u201D date above. You should consult this Privacy Policy regularly for any changes."
          ),
          React.createElement(
            "li",
            null,
            React.createElement(
              "u",
              null,
              "Questions and Feedback"
            ),
            ". We welcome your questions, comments, complaints and concerns about this Site, the Services, this Privacy Policy and/or our privacy practices regarding information we collect from users of the Site and Services. If you would like to report any security violations to us, or otherwise have any feedback or questions pertaining to our Site, Services and/or Privacy Policy please contact us at: ",
            React.createElement(
              "a",
              { href: "mailto:info@axios.com" },
              "info@axios.com"
            ),
            ", or Axios Media Inc., 3100 Clarendon Boulevard, Suite 200, Arlington VA 22201."
          )
        )
      )
    )
  );
};

export default Privacy;


// WEBPACK FOOTER //
// ./src/legal/components/Legal/Privacy.js